export const theme = {
  colors: {
    // Brand Primary
    primary: "#264653",           // Dark Blue-Green
    primaryLight: "#2A9D8F",      // Teal (secondary primary)
    primaryDark: "#1F3F43",       // Darker shade for borders/shadows
    primaryGlow: "rgba(42, 157, 143, 0.3)",

    // Neutrals & Backgrounds
    background: "#F4F1DE",           // Light Beige (main background)
    backgroundSecondary: "#E8E5D7",  // Slightly darker beige
    backgroundTertiary: "#DAD7C7",   // Muted beige for cards/sections
    backgroundCard: "#D0CCB8",       // Card base background

    // Typography
    textPrimary: "#1B1B1E",         // Almost Black (main text)
    textSecondary: "#3D3D40",       // Medium dark gray
    textMuted: "#6B6B6E",           // Muted gray
    textDark: "#0F0F11",            // Darker for subtle text

    // Accents
    accent: "#E9C46A",              // Warm Gold (accent)
    accentHover: "#D4B35B",         // Slightly darker gold hover
    accentGlow: "rgba(233, 196, 106, 0.4)",

    // Secondary Accent (Teal)
    secondary: "#2A9D8F",           // Teal
    secondaryHover: "#23897F",      // Darker teal on hover
    secondaryGlow: "rgba(42, 157, 143, 0.3)",

    // Status Colors (can keep or tweak)
    success: "#22C55E",
    warning: "#F4C430",
    error: "#DC2626",
    info: "#3B82F6",

    // Borders
    border: "#B7B39E",              // Soft beige/gray border
    borderLight: "#D5D1B3",         // Light border
    borderGlow: "rgba(233, 196, 106, 0.4)",

    // Gradients
    gradientPrimary: "linear-gradient(135deg, #264653, #2A9D8F)",
    gradientSecondary: "linear-gradient(135deg, #2A9D8F, #E9C46A)",
    gradientLight: "linear-gradient(135deg, #F4F1DE, #E8E5D7)",
    gradientCard: "linear-gradient(135deg, #D0CCB8, #DAD7C7)",
  },

  fonts: {
    primary: "'Inter', sans-serif",
    secondary: "'Poppins', sans-serif",
    mono: "'JetBrains Mono', monospace",
  },

  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem",
  },

  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },

  breakpoints: {
    xs: "320px",
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
    "3xl": "1920px",
  },

  spacing: {
    xs: "0.5rem",
    sm: "1rem",
    md: "1.5rem",
    lg: "2rem",
    xl: "3rem",
    "2xl": "4rem",
    "3xl": "6rem",
    "4xl": "8rem",
    "5xl": "10rem",
  },

  grid: {
    container: {
      xs: "100%",
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px",
    },
    columns: 12,
    gap: {
      xs: "1rem",
      sm: "1.5rem",
      md: "2rem",
      lg: "2.5rem",
      xl: "3rem",
    },
  },

  borderRadius: {
    sm: "0.375rem",
    md: "0.5rem",
    lg: "0.75rem",
    xl: "1rem",
    "2xl": "1.5rem",
    "3xl": "2rem",
    full: "9999px",
  },

  shadows: {
    sm: "0 1px 2px rgba(0,0,0,0.05)",
    md: "0 4px 6px rgba(0,0,0,0.1)",
    lg: "0 10px 15px rgba(0,0,0,0.15)",
    xl: "0 20px 25px rgba(0,0,0,0.2)",
    "2xl": "0 25px 50px rgba(0,0,0,0.25)",
    glow: "0 0 15px rgba(233, 196, 106, 0.3)",   // Gold glow
    glowStrong: "0 0 25px rgba(233, 196, 106, 0.5)",
  },

  transitions: {
    fast: "0.15s ease-in-out",
    normal: "0.3s ease-in-out",
    slow: "0.5s ease-in-out",
    bounce: "0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
  },

  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modal: 1040,
    popover: 1050,
    tooltip: 1060,
  },
};
